
import SharedNavigation from '../../components/feature/SharedNavigation';
import MirariEchoHero from './components/MirariEchoHero';
import MirariSection from './components/MirariSection';
import EchoSection from './components/EchoSection';
import EchoVideoGallery from './components/EchoVideoGallery';
import MirariEchoCTA from './components/MirariEchoCTA';
import SharedFooter from '../../components/feature/SharedFooter';

export default function MirariEchoPage() {
  return (
    <div className="relative">
      <SharedNavigation subLabel="Echo" />
      <MirariEchoHero />
      <MirariSection />
      <EchoSection />
      <EchoVideoGallery />
      <MirariEchoCTA />
      <SharedFooter />
    </div>
  );
}
